import BaseAPI from "./BaseAPI";
import { menuItemRoute } from "../routes";

export default class MenuItemAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, menuItemRoute, "menu-item");
    }
}
